import { getDynamicDataset } from "./index32.js";
import { validateApartmentEntrancesOnCorridor } from "./index184.js";
import { validateApartmentTravelDistances } from "./index185.js";
import { validateCoreRegulations } from "./index186.js";
import { RG_TYPE } from "@project-rouge/rg-core";
import { getRgObjectsOfType as getRgObjectsOfType$1 } from "@project-rouge/rg-three";
function ValidateAggregation(obj, dataset, aggProps) {
	const errors = /* @__PURE__ */ new Map();
	const zones = getRgObjectsOfType$1(obj, RG_TYPE.Zone);
	for (const zone of zones) {
		const dynamicDataset = aggProps ? getDynamicDataset(aggProps, zone) : dataset;
		const buildings = getRgObjectsOfType$1(zone, RG_TYPE.Building);
		for (const building of buildings) {
			const buildingMsgs = validateBuilding(building, dynamicDataset);
			if (buildingMsgs.length) errors.set(building.uuid, buildingMsgs);
		}
	}
	return errors;
}
function validateBuilding(building, dynamicDataset) {
	const buildingMsgs = [];
	if (!building.children.length) buildingMsgs.push("empty building");
	else {
		if (!building.children.some((c) => c.type === RG_TYPE.Core)) buildingMsgs.push("no cores");
		if (!building.children.some((c) => c.type === RG_TYPE.Entrance)) buildingMsgs.push("no entrances");
		if (!building.children.some((c) => c.type === RG_TYPE.Apartment)) buildingMsgs.push("no apartments");
		if (!validateApartmentTravelDistances(building, dynamicDataset.aggConfig)) buildingMsgs.push("incorrect travel distances");
		if (!validateApartmentEntrancesOnCorridor(building, dynamicDataset.aggConfig)) buildingMsgs.push("entrances do not open to corridors (potential clash)");
		if (!validateCoreRegulations(building, dynamicDataset)) buildingMsgs.push("type and count of cores do not conform to regulations");
	}
	return buildingMsgs;
}
export { ValidateAggregation };

//# sourceMappingURL=index187.js.map